import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { LoginForm } from 'modules/login';

@inject(rootStore => ({
    loginStore: rootStore.loginStore,
    resetStores: rootStore.reset
}))
@observer
class Login extends React.Component {
    constructor(props) {
        super(props);

        this.handleLogin = this.handleLogin.bind(this);
        props.resetStores();
    }

    async handleLogin(event) {
        event.preventDefault();
        const { form } = this.props.loginStore;
        await this.props.loginStore.login(form.fields.email.value, form.fields.password.value);
    }

    render() {
        const { form, onFieldChange, loading } = this.props.loginStore;
        return (
            <div>
                <LoginForm onSubmit={this.handleLogin}
                    form={form}
                    onChange={onFieldChange}
                    loading={loading} />
            </div>
        )
    }

}

export { Login }


// WEBPACK FOOTER //
// ./src/pages/Login.js